import { LookupItem } from "../../Shared/Models/LookupItem";
import Fee from "./Fee"
export default class Examination
{
    examinationId?: number;
    examinationDefinitionId: number;
    title: string;
    certificationId: number;
    certificationName: string;
    startDate: string;
    endDate: string;
    applicationDeadlineDate: string;
    applicationLateDeadlineDate: string;
    alternativePathwayEndDate: string;
    isMoc: boolean;
    isArticleBased: boolean;
    isPrimary: boolean;
    requiresFellowshipTraining: boolean;
    isCombinedMoc: boolean;
    fees: Array<Fee>;
    examinationModules: Array<ExaminationModule>;
    moduleTypes: Array<ModuleType>;
    otherBoardPathwayOptions: Array<OtherBoardPathwayOptionLookupItem>;
    practicePathwayOptions: Array<PracticePathwayOptionLookupItem>;
    pathwayOptions: Array<LookupItem>;
}

export class PracticePathwayOptionLookupItem {
    id: number;
    name: string;
}
export class OtherBoardPathwayOptionLookupItem {
    id: number;
    name: string;
}

export enum KnownExaminationDefinitions {
    Neurology = 1030,
    ChildNeurology = 1031,
    Psychiatry = 1038,
    NeurocriticalCare = 1058,
    BrainInjuryMedicine = 1041
}

export enum KnownCertifications {
    ClinicalNeurophysiology = 14
}

export class ExaminationModule {
    examinationModuleId: number;
    moduleTypeId: number;
}

export class ModuleType {
    moduleTypeId: number;
    certificationId: number;
}
